module.exports = __webpack_public_path__ + "static/media/loose.c9e8736d.mp3";